module.exports = __webpack_public_path__ + "img/course116_curriculum.31a1127e.png";